import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["id", "label", "children", "placeholder", "forceFocus", "validationState"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs as m, jsx as n } from "react/jsx-runtime";
import _ from "react";
import { c as r } from "../../../clsx-OuTLNxxd.js";
const u = "FloatLabel-module_field__pOinc",
  d = "FloatLabel-module_label__wTFxU",
  f = "FloatLabel-module_input__P5MJF",
  F = "FloatLabel-module_force-focus__BA6ql",
  b = "FloatLabel-module_with-error__yxssd",
  l = {
    field: u,
    label: d,
    input: f,
    forceFocus: F,
    withError: b
  },
  L = _ref => {
    let {
        id: o,
        label: t,
        children: e,
        placeholder: s = " ",
        forceFocus: a,
        validationState: c = void 0
      } = _ref,
      i = _objectWithoutProperties(_ref, _excluded);
    return /* @__PURE__ */m("div", {
      className: r(l.field, {
        [l.withError]: c == "error"
      }),
      children: [_.cloneElement(e, _objectSpread({
        className: "".concat(e.props.className, " ").concat(l.input),
        id: o,
        placeholder: s
      }, i)), /* @__PURE__ */n("label", {
        htmlFor: o,
        className: r(l.label, {
          [l.forceFocus]: a
        }),
        children: t
      })]
    });
  };
export { L as FloatLabel };